<modal>
  <span header class="uppercase">{{title}}</span>

  <table responsive class="data">
    <tr>
      <th class="text-top"><sortable [target]="details" [extractor]="extractor('SKU')">{{'Mã hàng' | lang}}</sortable></th>
      <th class="text-center text-top"><sortable [target]="details" [extractor]="extractor('Color')">{{'Màu' | lang}}</sortable></th>
      <th class="text-top"><sortable [target]="details" [extractor]="extractor(mode == 'full' ? 'ImportInvoiceTag' : mode == 'import' ? 'ImportInvoiceTag' : 'ExportInvoiceTag')">{{mode == 'full' ? 'Đơn nhập' : mode == 'import' ? 'Khách hàng' : 'Nguồn hàng' | lang}}</sortable></th>
      <th class="text-top"><sortable [target]="details" [extractor]="extractor(mode == 'full' ? 'ExportInvoiceTag' : mode == 'export' ? 'ImportInvoiceTag' : 'ExportInvoiceTag')">{{mode == 'full' ? 'Đơn xuất' : mode == 'export' ? 'Khách hàng' : 'Nguồn hàng' | lang}}</sortable></th>
      <th class="text-right text-top" *ngIf="mode != 'full'"><sortable [target]="details" [extractor]="extractor(mode == 'import' ? 'ImportUnitPrice' : 'ExportUnitPrice')">{{'Giá' | lang}}</sortable></th>
      <th class="text-right text-top" *ngIf="mode == 'full'"><sortable [target]="details" [extractor]="extractor('ImportUnitPrice')">{{'Giá nhập' | lang}}</sortable></th>
      <th class="text-right text-top" *ngIf="mode == 'full'"><sortable [target]="details" [extractor]="extractor('ExportUnitPrice')">{{'Giá xuất' | lang}}</sortable></th>
      <th class="text-right text-top"><sortable [target]="details" [extractor]="extractor('ActualQuantity')">{{'Dài / nặng' | lang}}</sortable></th>
      <th class="text-right text-top"><sortable [target]="details" [extractor]="extractor('ReducedQuantity')">{{'Trừ gốc' | lang}}</sortable></th>
      <th class="text-right text-top"><sortable [target]="details" [extractor]="extractor('QuoteQuantity')">{{'Tính tiền' | lang}}</sortable></th>
      <th class="text-right text-top" *ngIf="mode != 'full'"><sortable [target]="details" [extractor]="extractor(mode == 'import' ? 'ImportDiscountQuantity' : 'ExportDiscountQuantity')">{{'Trừ lỗi' | lang}}</sortable></th>
      <th class="text-right text-top" *ngIf="mode == 'full'"><sortable [target]="details" [extractor]="extractor('ImportDiscountQuantity')">{{'Trừ NCC' | lang}}</sortable></th>
      <th class="text-right text-top" *ngIf="mode == 'full'"><sortable [target]="details" [extractor]="extractor('ExportDiscountQuantity')">{{'Trừ cho khách' | lang}}</sortable></th>
      <th class="text-right text-top" *ngIf="mode != 'full'"><sortable [target]="details" [extractor]="extractor(mode == 'import' ? 'ImportDiscountAmount' : 'ExportDiscountAmount')">{{'Tổng trừ' | lang}}</sortable></th>
      <th class="text-right text-top" *ngIf="mode == 'full'"><sortable [target]="details" [extractor]="extractor('ImportDiscountAmount')">{{'Tổng trừ NCC' | lang}}</sortable></th>
      <th class="text-right text-top" *ngIf="mode == 'full'"><sortable [target]="details" [extractor]="extractor('ExportDiscountAmount')">{{'Tổng trừ cho khách' | lang}}</sortable></th>
    </tr>
    <ng-container>
      <tr *ngFor="let o of details.matches">
        <td>
          <good class="text-primary spacy bold nowrap" [sku]="o.SKU"></good>
        </td>
        <td class="text-primary">{{o.Color}}</td>
        <td>
          <invoice [tag]="mode == 'full' ? o.ImportInvoiceTag : mode == 'import' ? o.ExportInvoiceTag : o.ImportInvoiceTag" [displays]="{ partner: true }"></invoice>
        </td>
        <td>
          <invoice [tag]="mode == 'full' ? o.ExportInvoiceTag : mode == 'export' ? o.ExportInvoiceTag : o.ImportInvoiceTag" [displays]="{ partner: true }"></invoice>
        </td>
        <td *ngIf="mode != 'full'">
          {{(mode == 'import' ? o.ImportUnitPrice : o.ExportUnitPrice) | number : '1.0-1' : 'en-US'}}
          <symbol-per-unit [symbol]="mode == 'import' ? discount.ImportDiscountSymbol : discount.ExportDiscountSymbol" [type]="o.Unit"></symbol-per-unit>
        </td>
        <td *ngIf="mode == 'full'">
          {{o.ImportUnitPrice | number : '1.0-1' : 'en-US'}}
          <symbol-per-unit [symbol]="discount.ImportDiscountSymbol" [type]="o.Unit"></symbol-per-unit>
        </td>
        <td *ngIf="mode == 'full'">
          {{o.ExportUnitPrice | number : '1.0-0' : 'en-US'}}
          <symbol-per-unit [symbol]="discount.ExportDiscountSymbol" [type]="o.Unit"></symbol-per-unit>
        </td>
        <td>
          <b class="text-info">{{o.ActualQuantity | number : '1.1-1' : 'en-US'}}</b>
          <product-unit [type]="o.Unit"></product-unit>
        </td>
        <td>
          <b class="text-danger">{{o.ActualQuantity - (mode == 'import' ? o.ImportQuoteQuantity : o.ExportQuoteQuantity) | number : '1.1-1' : 'en-US'}}</b>
          <product-unit [type]="o.Unit"></product-unit>
        </td>
        <td>
          <b class="text-primary">{{(mode == 'import' ? o.ImportQuoteQuantity : o.ExportQuoteQuantity) | number : '1.1-1' : 'en-US'}}</b>
          <product-unit [type]="o.Unit"></product-unit>
        </td>
        <td *ngIf="mode != 'full'">
          <b class="text-danger">{{(mode == 'import' ? o.ImportDiscountQuantity : o.ExportDiscountQuantity) | number : '1.1-1' : 'en-US'}}</b>
          <product-unit [type]="o.Unit"></product-unit>
        </td>
        <td *ngIf="mode == 'full'">
          <b class="text-danger">{{o.ImportDiscountQuantity | number : '1.1-1' : 'en-US'}}</b>
          <product-unit [type]="o.Unit"></product-unit>
        </td>
        <td *ngIf="mode == 'full'">
          <b class="text-danger">{{o.ExportDiscountQuantity | number : '1.1-1' : 'en-US'}}</b>
          <product-unit [type]="o.Unit"></product-unit>
        </td>
        <td *ngIf="mode != 'full'">
          <b class="text-danger">{{(mode == 'import' ? o.ImportDiscountQuantity * o.ImportUnitPrice : o.ExportDiscountQuantity * o.ExportUnitPrice) | number : '1.0-1' : 'en-US'}}</b>
          <unit>{{icon}}</unit>
        </td>
        <td *ngIf="mode == 'full'">
          <b class="text-success">{{o.ImportDiscountQuantity * o.ImportUnitPrice | number : '1.0-1' : 'en-US'}}</b>
          <unit>{{discount.ImportDiscountIcon}}</unit>
        </td>
        <td *ngIf="mode == 'full'">
          <b class="text-danger">{{o.ExportDiscountQuantity * o.ExportUnitPrice | number : '1.0-0' : 'en-US'}}</b>
          <unit>{{discount.ExportDiscountIcon}}</unit>
        </td>
      </tr>
    </ng-container>
    <tr class="footer" *ngIf="details.matches.length > 1">
      <td class="bold">{{'TỔNG' | lang}}</td>
      <td></td>
      <td></td>
      <td *ngIf="mode == 'full'"></td>
      <td></td>
      <td></td>
      <td>
        <b>{{sum('ActualQuantity') | number : '1.1-1' : 'en-US'}}</b>
        <m *ngIf="hasLength && !hasWeight"></m>
        <kg *ngIf="!hasLength && hasWeight"></kg>
        <unit *ngIf="hasLength && hasWeight">{{'đv' | lang}}</unit>
      </td>
      <td>
        <b>{{sum('ReducedQuantity') | number : '1.1-1' : 'en-US'}}</b>
        <m *ngIf="hasLength && !hasWeight"></m>
        <kg *ngIf="!hasLength && hasWeight"></kg>
        <unit *ngIf="hasLength && hasWeight">{{'đv' | lang}}</unit>
      </td>
      <td>
        <b>{{sum('ExportQuoteQuantity') | number : '1.1-1' : 'en-US'}}</b>
        <m *ngIf="hasLength && !hasWeight"></m>
        <kg *ngIf="!hasLength && hasWeight"></kg>
        <unit *ngIf="hasLength && hasWeight">{{'đv' | lang}}</unit>
      </td>
      <td *ngIf="mode != 'full'">
        <b>{{sum(mode == 'import' ? 'ImportDiscountQuantity' : 'ExportDiscountQuantity') | number : '1.1-1' : 'en-US'}}</b>
        <m *ngIf="hasLength && !hasWeight"></m>
        <kg *ngIf="!hasLength && hasWeight"></kg>
        <unit *ngIf="hasLength && hasWeight">{{'đv' | lang}}</unit>
      </td>
      <td *ngIf="mode == 'full'">
        <b>{{sum('ImportDiscountQuantity') | number : '1.1-1' : 'en-US'}}</b>
        <m *ngIf="hasLength && !hasWeight"></m>
        <kg *ngIf="!hasLength && hasWeight"></kg>
        <unit *ngIf="hasLength && hasWeight">{{'đv' | lang}}</unit>
      </td>
      <td *ngIf="mode == 'full'">
        <b>{{sum('ExportDiscountQuantity') | number : '1.1-1' : 'en-US'}}</b>
        <m *ngIf="hasLength && !hasWeight"></m>
        <kg *ngIf="!hasLength && hasWeight"></kg>
        <unit *ngIf="hasLength && hasWeight">{{'đv' | lang}}</unit>
      </td>
      <td *ngIf="mode != 'full'">
        <b>{{total | number : '1.0-1' : 'en-US'}}</b>
        <unit>{{icon}}</unit>
      </td>
      <td *ngIf="mode == 'full'">
        <b>{{sum('ImportDiscountAmount') | number : '1.0-1' : 'en-US'}}</b>
        <unit>{{discount.ImportDiscountIcon}}</unit>
      </td>
      <td *ngIf="mode == 'full'">
        <b>{{sum('ExportDiscountAmount') | number : '1.0-0' : 'en-US'}}</b>
        <unit>{{discount.ExportDiscountIcon}}</unit>
      </td>
    </tr>
  </table>

  <collapsible *ngIf="counters.length > 0">
    <div header class="uppercase">{{'Các khoản được đối trừ' | lang}}</div>
    <table responsive class="data">
      <tr>
        <th class="text-top">{{'Ngày' | lang}}</th>
        <th class="text-top">{{'Khoản đối trừ' | lang}}</th>
        <th class="text-top text-right">{{'Công nợ' | lang}}</th>
      </tr>
      <tr *ngFor="let i of counters">
        <td>
          <span class="bold nowrap">{{i.Stamp | date : 'dd-MM-yyyy'}}</span>
        </td>
        <td class="bold text-primary nowrap">{{i.Tag}}</td>
        <td class="nowrap">
          <span [ngClass]="{'text-danger': type == 'expense', 'text-success': type == 'income'}">{{i.Amount | number : '1.0-1' : 'en-US'}}</span>
          <unit>{{icon}}</unit>
        </td>
      </tr>
      <tr class="footer bold" *ngIf="counters.length > 1">
        <td>{{'TỔNG' | lang}}</td>
        <td></td>
        <td>
          <span [ngClass]="{'text-danger': type == 'expense', 'text-success': type == 'income'}">{{countered | number : '1.0-1' : 'en-US'}}</span>
          <unit>{{icon}}</unit>
        </td>
      </tr>
      <tr class="bold">
        <td class="text-primary">{{'CHƯA ĐỐI TRỪ' | lang}}</td>
        <td></td>
        <td>
          <span class="text-primary">{{left | number : '1.0-1' : 'en-US'}}</span>
          <unit>{{icon}}</unit>
        </td>
      </tr>
    </table>
  </collapsible>

</modal>
